/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {
  CpdsInlinePullQuoteAuthorStyleTag,
  CpdsInlinePullQuoteContainerStyleTag,
  CpdsInlinePullQuoteJobTitleStyleTag,
  CpdsInlinePullQuoteQuotationMark,
  CpdsInlinePullQuoteStyleTag,
  CpdsInlinePullQuoteTitleStyleTag,
} from './styles/cpds-inline-pull-quote-style';
import { CpdsInlinePullQuoteProps } from './typings';
import { useStores } from '../../utils/useStore';

const CpdsInlinePullQuote: React.FC<CpdsInlinePullQuoteProps> = (props) => {
  const { domRef, exClasses, styleOverrides, title, author, jobTitle, background } = props;

  const {
    context: {
      site: { brand },
    },
  } = useStores();

  const path = {
    expedia: (
      <path d="M13.2 9.0566C9.6 12.4528 7.6 16.7924 7.2 22.0755C8.8 20.1887 11.2 19.2453 14.2 19.2453C17 19.2453 19.4 20.1887 21.4 22.0755C23.4 23.9623 24.4 26.2264 24.4 28.8679C24.4 32.0755 23.2 34.717 20.8 36.7924C18.4 39.0566 15.4 40 12 40C8.6 40 5.8 38.8679 3.4 36.6038C0.999999 34.3396 0 31.1321 0 26.9811C0 22.6415 0.999999 18.4906 3.4 14.3396C5.6 10.1887 8.8 6.98113 12.8 4.33962C16.8 1.69811 21.2 0.377354 26.2 0L26 2.64151C21 3.5849 16.8 5.66037 13.2 9.0566ZM47 9.0566C43.4 12.4528 41.4 16.7924 41 22.0755C42.6 20.1887 45 19.2453 48 19.2453C50.8 19.2453 53.2 20.1887 55.2 22.0755C57.2 23.9623 58.2 26.2264 58.2 28.8679C58.2 32.0755 57 34.717 54.6 36.7924C52.2 39.0566 49.2 40 45.8 40C42.4 40 39.6 38.8679 37.2 36.6038C34.8 34.3396 33.8 31.1321 33.8 26.9811C33.8 22.6415 34.8 18.4906 37.2 14.3396C39.4 10.1887 42.6 6.98113 46.6 4.33962C50.6 1.69811 55 0.377354 60 0L59.8 2.64151C54.8 3.5849 50.6 5.66037 47 9.0566Z" />
    ),
    hotels: (
      <path d="M13.126 0H26.9357L1.50402 22.6582H18.5952V40H0V22.6582L13.126 0ZM37.1903 0H51L25.7051 22.6582H42.6595V40H24.0643V22.6582L37.1903 0Z" />
    ),
    vrbo: (
      <path d="M13.2 9.0566C9.6 12.4528 7.6 16.7924 7.2 22.0755C8.8 20.1887 11.2 19.2453 14.2 19.2453C17 19.2453 19.4 20.1887 21.4 22.0755C23.4 23.9623 24.4 26.2264 24.4 28.8679C24.4 32.0755 23.2 34.717 20.8 36.7924C18.4 39.0566 15.4 40 12 40C8.6 40 5.8 38.8679 3.4 36.6038C0.999999 34.3396 0 31.1321 0 26.9811C0 22.6415 0.999999 18.4906 3.4 14.3396C5.6 10.1887 8.8 6.98113 12.8 4.33962C16.8 1.69811 21.2 0.377354 26.2 0L26 2.64151C21 3.5849 16.8 5.66037 13.2 9.0566ZM47 9.0566C43.4 12.4528 41.4 16.7924 41 22.0755C42.6 20.1887 45 19.2453 48 19.2453C50.8 19.2453 53.2 20.1887 55.2 22.0755C57.2 23.9623 58.2 26.2264 58.2 28.8679C58.2 32.0755 57 34.717 54.6 36.7924C52.2 39.0566 49.2 40 45.8 40C42.4 40 39.6 38.8679 37.2 36.6038C34.8 34.3396 33.8 31.1321 33.8 26.9811C33.8 22.6415 34.8 18.4906 37.2 14.3396C39.4 10.1887 42.6 6.98113 46.6 4.33962C50.6 1.69811 55 0.377354 60 0L59.8 2.64151C54.8 3.5849 50.6 5.66037 47 9.0566Z" />
    ),
  };

  return (
    <CpdsInlinePullQuoteStyleTag
      className={`cpds-inline-pull-quote ${exClasses}`}
      ref={domRef}
      styleOverrides={styleOverrides}
      background={background}
    >
      <CpdsInlinePullQuoteContainerStyleTag>
        <CpdsInlinePullQuoteQuotationMark
          viewBox="0 0 60 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          background={background}
        >
          {path[brand]}
        </CpdsInlinePullQuoteQuotationMark>
        <CpdsInlinePullQuoteTitleStyleTag {...props} dangerouslySetInnerHTML={{ __html: title  }} className='cpds-display-roman-book-03'/>
        <CpdsInlinePullQuoteAuthorStyleTag {...props} className='cpds-body-roman-medium-08'>{author} </CpdsInlinePullQuoteAuthorStyleTag>
        <CpdsInlinePullQuoteJobTitleStyleTag {...props} className='cpds-body-roman-book-08'>{jobTitle} </CpdsInlinePullQuoteJobTitleStyleTag>
      </CpdsInlinePullQuoteContainerStyleTag>
    </CpdsInlinePullQuoteStyleTag>
  );
};

export default CpdsInlinePullQuote;


